export default "__VITE_ASSET__WYynaTR27qS79TqavLPOQA__"